"use client";

import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Star } from "lucide-react";
function RoasterPostsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-80 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-sm text-muted-foreground py-12">
        Failed to load roaster posts. Please try again later.
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        No roaster posts available at the moment.
      </div>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {displayPosts.map((post, i) => <Card key={post.id} data-index={i} className="card bg-background shadow-[0_4px_16px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
          {post.featuredImage && <div className="w-full h-48 overflow-hidden rounded-t-xl">
              <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover" />
            </div>}
          <CardHeader>
            <CardTitle className="text-xl font-display text-foreground">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-accent text-accent" />)}
              <span className="ml-2 text-sm font-semibold text-muted-foreground">
                5.0
              </span>
            </div>
            {post.excerpt && <div className="text-sm text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
          </CardContent>
          <CardFooter>
            {post.link && <Link to={post.link} className="text-sm font-semibold text-primary hover:text-primary-hover underline hover:no-underline transition-all duration-[var(--duration-fast)]">
                Read More →
              </Link>}
          </CardFooter>
        </Card>)}
    </div>;
}
export default function LatestRoasterPosts() {
  return <section className="py-16 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground text-center mb-12">
          Latest Roaster Posts
        </h2>
        <PostsProvider className="posts-section-wrapper" wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "_embedded", "_links.wp:featuredmedia"]}>
          <RoasterPostsConsumer />
        </PostsProvider>
      </div>
    </section>;
}